import React from 'react';
import styled from 'styled-components';

interface CloseButtonProps {
  onClick: (event: React.MouseEvent) => void;
  size?: 'sm' | 'md' | 'lg';
}

const fontSizes = {
  sm: '14px',
  md: '16px',
  lg: '20px',
};

const StyledCloseButton = styled.button<{ size?: 'sm' | 'md' | 'lg' }>`
  background: none;
  border: none;
  font-size: ${({ size = 'md' }) => fontSizes[size] || fontSizes.md};
  padding: 8px;
  margin-top: -8px;
  float: right;
  line-height: 1;
  font-weight: bold;
  opacity: 0.7;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: none;
  }
`;

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick, size = 'md' }) => {
  return (
    <StyledCloseButton onClick={onClick} size={size} aria-label="Close">
      &times;
    </StyledCloseButton>
  );
};
